import { z } from "zod";

export class SharedApiError extends Error {
  status: number;
  details?: unknown;

  constructor(message: string, status: number, details?: unknown) {
    super(message);
    this.name = "SharedApiError";
    this.status = status;
    this.details = details;
  }
}

export type FetchLike = (
  input: string,
  init?: RequestInit,
) => Promise<Response>;

export function normalizeApiBaseUrl(apiBaseUrl: string): string {
  return apiBaseUrl.endsWith("/") ? apiBaseUrl.slice(0, -1) : apiBaseUrl;
}

export const apiErrorSchema = z.object({
  error: z.string(),
  details: z.unknown().optional(),
});

export async function parseErrorResponse(
  response: Response,
  fallbackMessage: string,
): Promise<SharedApiError> {
  const payload =
    typeof response.json === "function"
      ? await response.json().catch(() => null)
      : null;
  const parsed = apiErrorSchema.safeParse(payload);
  if (parsed.success) {
    return new SharedApiError(
      parsed.data.error,
      response.status,
      parsed.data.details,
    );
  }
  return new SharedApiError(fallbackMessage, response.status);
}
